/** CSGSphere3D registration: the parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseCSGSphere3D } from './parser';
const csgSphere3DRegistration = {
    typeName: 'CSGSphere3D',
    parser: parseCSGSphere3D,
};
nodeRegistry.register(csgSphere3DRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map